import { Injectable } from '@angular/core';
import { blobToBase64 } from 'src/app/utils/BlobToBase64';

@Injectable({
  providedIn: 'root'
})
export class Base64Service {

  constructor() { }

  async convertToBase64(pdfSrc: string) {
    const response = await fetch(pdfSrc);
    const blob = await response.blob();

    // convert blob to base64
    const base64 = (await blobToBase64(blob)) as string;

    // remove data:application/pdf;base64, from the start of the string
    return base64.replace("data:application/pdf;base64,", "");
  }

  async convertBlobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        // Extract the Base64 string from the data URL
        const base64String = reader.result as string;
        resolve(base64String.split(',')[1]); // Return only the Base64 part
      };
      reader.onerror = (error) => {
        reject(error);
      };
    });
  }

  async convertFileToBase64(file: File) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  }
}
